"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultConfigurationAppliedNonAuth = void 0;
/**
 * A builder for DefaultConfigurationAppliedNonAuth
 *
 * @param data - The event data
 * @return The formatted event data for DefaultConfigurationAppliedNonAuthEvent
 */
function createDefaultConfigurationAppliedNonAuth(data) {
    return {
        name: 'DefaultConfigurationAppliedNonAuth',
        environments: ['devicenonauth', 'browsernonauth'],
        data: data,
    };
}
exports.createDefaultConfigurationAppliedNonAuth = createDefaultConfigurationAppliedNonAuth;
//# sourceMappingURL=createDefaultConfigurationAppliedNonAuth.js.map